<div class="color-preset-picker" [class.disabled]="isDisabled">
  <div class="color"
       *ngFor="let color of colorPresets"
       [style.background]="colorAsGradient(color)"
       (click)="setColor(color)">
    <nb-icon icon="checkmark-outline" pack="eva"
             *ngIf="value === color"
             [style.color]="getContrastColor(color)"></nb-icon>
  </div>
  <div class="color"
       *ngIf="!isDisabled && editColor() as editColor"
       (click)="colorInput.click()"
       [style.background]="editColor.background">
    <nb-icon pack="eva" icon="edit-outline" [style.color]="editColor.color"></nb-icon>
  </div>
  <div class="color" *ngIf="isDisabled && !isPresetColor(value)" [style.background]="colorAsGradient(valueSignal()!)">
    <nb-icon icon="checkmark-outline" pack="eva" [style.color]="getContrastColor(valueSignal()!)"></nb-icon>
  </div>
  <div class="custom-picker">
    <input
      #colorInput
      nbInput
      fullWidth
      type="color"
      [(ngModel)]="value"
      [disabled]="isDisabled">
  </div>
</div>
